/* eslint  no-undef:0 */
import 'TeWanangaRedesign/lib/jquery.validate';
import 'chosen-js';

// enrollment-form
var TWoA = TWoA || {};
export default TWoA.Enrolment = TWoA.Enrolment || {};

var ethnicOtherOptions = [false, false, false];
var ethnicMaoriOptions = [false, false, false];
var currentYear = new Date().getFullYear();
var totalYearsToShow = 66;
var dobInputValue = {
    day: 'Not Specified',
    month: 'Not Specified',
    year: 'Not Specified'
};

var currentStepNumber = '.step-1';
var ignoredFormFields = ignoredFields('.step-1');
var $currentActiveStep = $('.step-1').addClass('active');
var $window = $(window);

$(document).ready(function () {
    $('.chzn-select').chosen({ width: '100%' });
    checkNewUser();
});

window.validationInstance = $('form').each((i, item) => $(item).validate({
    ignore: ignoredFormFields,
    errorClass: 'error',
    errorPlacement (error, element) {
        var $requiredField = element.closest('.required-field');

        if ($requiredField.length === 0) {
            $requiredField = element.closest('.required-dob-field');
        }

        if ($requiredField.hasClass('required-terms')) {
            $requiredField.next().append(error);
        } else {
            $requiredField.append(error);
        }
    },
    invalidHandler (form, validator) {

        if (!validator.numberOfInvalids())
            return;

        $('html, body').animate({
            scrollTop: $(validator.errorList[0].element).parent().offset().top - 100
        }, 500);
        $(validator.errorList[0].element).focus();
    }
}));

$('.required-field').each(function () {
    ////console.log(this);
    var $this = $(this);
    var validationMessage = $this.attr('data-validation');

    if (validationMessage === undefined) {
        validationMessage = 'This field is required.';
    }

    var $inputsWithChosenContainer = $(this).find('input, select');

    $inputsWithChosenContainer.rules('add', {
        required: true,
        messages: {
            required: validationMessage
        }
    });
});

//only submit the form if it is valid
$('#btnOK').on('click', function (e) {
    var v = $('#form').valid();

    v = validateCurrentChosenDropdowns(v);

    ////console.log($('#form').valid());

    if (!v) {
        e.preventDefault();

    }
    else {
        //Might be better to move this code to a form submit event
        $(this).val('Sending...');
        $('#btnOK').attr('disabled', 'disabled');

        //form doesnt submit if button is disabled so have to submit manually
        $('#form').submit();
    }

    return true;
});

$('.enrolment-nav-item').on('click', function (e) {

    var $this = $(this);
    e.preventDefault();

    var stepNumber = $this.attr('data-moveto');

    var isValid = false;
    if (!$this.hasClass('previous')) {

        if ($this.attr('data-validate')) {
            isValid = $('#form').valid();
        }

        isValid = validateCurrentChosenDropdowns(isValid);
    }

    if ($this.hasClass('previous') || stepNumber !== undefined && isValid) {
        postAjaxFormSection();
        showStep(stepNumber);
    }

    if ($this.hasClass('previous') || stepNumber !== undefined && isValid) {
        //set the header background
        $('#enrolment-header').removeClass('step-1');
        $('#enrolment-header').removeClass('step-2');
        $('#enrolment-header').removeClass('step-3');
        $('#enrolment-header').removeClass('step-4');
        $('#re-enrolment-header').removeClass('step-1');
        $('#re-enrolment-header').removeClass('step-2');
        $('#re-enrolment-header').removeClass('step-3');

        $('#enrolment-header').addClass(stepNumber.replace('.', ''));
        $('#re-enrolment-header').addClass(stepNumber.replace('.', ''));

    }

});

$('.chzn-select').change(function () {
    //alert('chosen changed : jquery ' + $.fn.jQuery);
    $(this).valid();
});

$('.prepend-option').each(function () {
    $(this).prepend(generateOption()).val('').trigger('chosen:updated');
});

//Populate values
var dobYears = generateYears('reversed', 90);
$('#dob-year').append(dobYears).trigger('chosen:updated');

populateFieldValues();

bindEventsForConditionalFields();

function validateCurrentChosenDropdowns (isValid)
{
    $currentActiveStep.find('.chzn-select').each(function () {
        var isChznSelectValid = $(this).valid();
        if (!isChznSelectValid) {
            isValid = isChznSelectValid;
        }

    });

    return isValid;
}

function applyValidation () {

    window.validationInstance = $('#form').validate({
        ignore: ignoredFormFields,
        errorClass: 'error',
        errorPlacement (error, element) {
            var $requiredField = element.closest('.required-field');

            if ($requiredField.length === 0) {
                $requiredField = element.closest('.required-dob-field');
            }

            if ($requiredField.hasClass('required-terms')) {
                $requiredField.next().append(error);
            } else {
                $requiredField.append(error);
            }
        },
        invalidHandler (form, validator) {

            if (!validator.numberOfInvalids())
                return;

            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).parent().offset().top - 100}, 2000);

            $(validator.errorList[0].element).focus();
        }
    });

    $('.required-field').each(function () {
        //// console.log( this );
        var $this = $(this);
        var validationMessage = $this.attr('data-validation');

        if (validationMessage === undefined) {
            validationMessage = 'This field is required.';
        }

        var $inputsWithChosenContainer = $(this).find('input, select');

        $inputsWithChosenContainer.rules('add', {
            required: true,
            messages: {
                required: validationMessage
            }
        });
    });
}

function populateFieldValues () {
    populateFieldValuesForStep1();
    populateFieldValuesForStep2();
    populateFieldValuesForStep3();
}

function populateFieldValuesForStep1 () {
    var $deliveryLocationDropdown = $('#delivery-location select');
    var $programmeOfInterestDropdown = $('#programme-of-interest select');
    var $semestersDropdown = $('#semester select');

    $deliveryLocationDropdown.on('change', function (e) {

        var selectedVal = $deliveryLocationDropdown.val();

        if (!selectedVal || selectedVal === '-1') {
            addAjaxOptionsToElement({}, $programmeOfInterestDropdown, true);
            addAjaxOptionsToElement({}, $semestersDropdown, true);
        } else {
            getProgrammes(selectedVal, $programmeOfInterestDropdown);
        }

    });

    $programmeOfInterestDropdown.on('change', function (e) {

        var locationVal = $deliveryLocationDropdown.val();
        var programmeVal = $programmeOfInterestDropdown.val();

        if (!programmeVal || programmeVal === '-1') {
            addAjaxOptionsToElement({}, $semestersDropdown, true);
        } else {

            getSemesters(locationVal, programmeVal, $semestersDropdown);

            $semestersDropdown.valid();

        }

    });

    $semestersDropdown.on('chosen:updated', function (e) {
        $semestersDropdown.valid();
    });

}

function getProgrammes (siteId, el) {

    $.ajax({
        type: 'POST',
        url: dataRequest.deliverySiteProgrammesUrl,
        data: `{siteId: "${siteId}"}`,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success (response) {

            var addEmptyOption = response.length > 0 && response[0].Id !== '-1';
            addAjaxSelectOptionsToElement(response, el, addEmptyOption);

        }
    });
}

function getSemesters (regionId, programmeId, el) {

    $.ajax({
        type: 'POST',
        url: dataRequest.deliverySiteProgrammeSemestersUrl,
        data: `{regionId: "${regionId}", programmeId: "${programmeId}"}`,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success (response) {

            addAjaxSelectOptionsToElement(response, el, false);

        }
    });
}

function postAjaxFormSection () {

    var data = $('#form').serialize();

    data = data.replace(/\'/g, "\\'");

    //alert('data now='+data);
    $.ajax({
        type: 'POST',
        url: dataRequest.saveIncompletFormsUrl,
        data: `{jsonForm: "${data}"}`,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success (response) {
            //alert(response);

        }
    });
}

function addAjaxSelectOptionsToElement (options, element, addEmptyOption) {

    element.find('option').remove();

    if (addEmptyOption) {
        element.prepend(generateOption());
    }

    for (var i = 0; i < options.length; i++) {
        var val = options[i].Value;
        var text = options[i].Text;
        element.append(`<option value="${val}">${text}</option>`);
    }

    element.trigger('chosen:updated');
}

function addAjaxOptionsToElement (options, element, addEmptyOption) {

    element.find('option').remove();

    if (addEmptyOption) {
        element.prepend(generateOption());
    }

    for (var i = 0; i < options.length; i++) {
        var val = options[i].Id;
        var text = options[i].Name;
        element.append(`<option value="${val}">${text}</option>`);
    }

    element.trigger('chosen:updated');
}

function populateFieldValuesForStep2 () {

    dateOfBirthField();

    //$('.prior-activity-select-dropdown').prepend(generateOption());

    var currentText = null;

    if ($('#residancy-status .chzn-select').val() !== null) {
        currentText = $(':selected', '#residancy-status .chzn-select').text();

        if (currentText.indexOf('permanent resident') > -1) {
            $('#dependant-residancy-status').addClass('show');
        }
    }

    if ($('#ethnicity .chzn-select').val() !== null) {

        var v = $('#ethnicity .chzn-select').val();

        //If Account created with default 'Not Stated' value, then remove the selected option, so they are forced to set the value.
        if (v === '999') {
            $('#Ethnicity_dropDownList').find('option').removeAttr('selected');
        } else {

            currentText = $(':selected', '#ethnicity .chzn-select').text();

            if (currentText.indexOf('Other') > -1) {
                ethnicOtherOptions[0] = true;
            } else if (currentText.indexOf('Māori') > -1 || currentText.indexOf('Maori') > -1) {
                ethnicMaoriOptions[0] = true;
            }
        }
    }

    if ($('#ethnicity2 .chzn-select').val() !== null) {
        currentText = $(':selected', '#ethnicity2 .chzn-select').text();

        if (currentText.indexOf('Other') > -1) {
            ethnicOtherOptions[1] = true;
        } else if (currentText.indexOf('Māori') > -1 || currentText.indexOf('Maori') > -1) {
            ethnicMaoriOptions[1] = true;
        }
    }

    if ($('#ethnicity3 .chzn-select').val() !== null) {
        currentText = $(':selected', '#ethnicity3 .chzn-select').text();

        if (currentText.indexOf('Other') > -1) {
            ethnicOtherOptions[1] = true;
        } else if (currentText.indexOf('Māori') > -1 || currentText.indexOf('Maori') > -1) {
            ethnicMaoriOptions[1] = true;
        }
    }

    setEthenicityFields();

    if ($('#disability input[type="radio"]').is(':checked')) {
        currentText = $('#disability input[type="radio"]').val();
        var isDisability = $('#disability #Disability_list_0').is(':checked');

        if (isDisability) {
            $('#dependant-disability').addClass('show');
            $('#dependant-disability').show();
        }
        else {
            $('#dependant-disability').removeClass('show');
            $('#dependant-disability').hide();
        }
    }
}

var isMaoriSelected = false;

function setEthenicityFields () {
    //alert('setEthenicityFields');
    //alert('ethnicOtherOptions[0] = ' + ethnicOtherOptions[0] + ' ethnicOtherOptions[1] = ' + ethnicOtherOptions[1] + ' ethnicOtherOptions[2] = ' + ethnicOtherOptions[2])
    //alert('ethnicMaoriOptions[0] = ' + ethnicMaoriOptions[0] + ' ethnicMaoriOptions[1] = ' + ethnicMaoriOptions[1] + ' ethnicMaoriOptions[2] = ' + ethnicMaoriOptions[2])

    if (ethnicOtherOptions[0] || ethnicOtherOptions[1] || ethnicOtherOptions[2]) {
        $('#dependant-ethnicity').addClass('show');
        $('#dependant-ethnicity').show();
    } else {
        $('#dependant-ethnicity').removeClass('show');
        $('#dependant-ethnicity').hide();
    }

    if (ethnicMaoriOptions[0] || ethnicMaoriOptions[1] || ethnicMaoriOptions[2]) {

        //move the dependant-ethnicity1 div below the relevent ethnicity selection
        if (ethnicMaoriOptions[0]) {
            //alert('0');
            $('#dependant-ethnicity1').insertAfter($('#ethnicity-1'));
        }
        else if (ethnicMaoriOptions[1]) {
            //alert('1');
            $('#dependant-ethnicity1').insertAfter($('#ethnicity-2'));
        }
        else if (ethnicMaoriOptions[2]) {
            //alert('2');
            $('#dependant-ethnicity1').insertAfter($('#ethnicity-3'));
        }

        $('#dependant-ethnicity1').addClass('show');
        $('#dependant-ethnicity1').show();

        //set required for Iwi/Rohe 1
        $('#divIwi1').parent().addClass('required-field');

        isMaoriSelected = true;

        applyValidation();

    } else {
        //alert('hide ethnicity');

        $('#dependant-ethnicity1').removeClass('show');
        $('#dependant-ethnicity1').hide();

        //remove required for Iwi/Rohe 1
        //$('#Iwi1_dropDownList').parent().removeClass('required-field');
        //$('#Iwi1_dropDownList').parent().removeClass('error');
        $('#divIwi1').parent().removeClass('required-field');
        $('#divIwi1').parent().removeClass('error');

        //Set validation as error in IE
        if (isMaoriSelected && $('#Iwi1_dropDownList').val() === '') {
            $('#Iwi1_dropDownList').val('4444').change();
            $('#Iwi1_dropDownList').trigger('chosen:updated');
        }

        applyValidation();
    }
}

function populateFieldValuesForStep3 () {

    /*
    $('.last-secondary-school-year, .year-to-complete-academic-requirement').find('option').remove();

    $('.last-secondary-school-year, .year-to-complete-academic-requirement').each(function () {
        $(this).prepend(generateOption());
    });

    $('.last-secondary-school-year').append(generateYears('reversed')).trigger('liszt:updated');

    $('.year-to-complete-academic-requirement').append(generateYears()).trigger('liszt:updated');

    */
    /*
    $('.year-to-complete-academic-requirement').find('option').remove();

    $('.year-to-complete-academic-requirement').each(function () {
        $(this).prepend(generateOption());
    });
    */

    $('.year-to-complete-academic-requirement').append(generateYears()).trigger('chosen:updated');

    if ($('#divFirstYearOfStudy input[type="radio"]').is(':checked')) {
        var currentText = $('#divFirstYearOfStudy input[type="radio"]:checked').val();
        //alert(currentText);
        if (currentText === 'No') {
            $('#prior-Tertiary').addClass('show');
            $('#prior-Tertiary').show();
            //$('#divHighestTertiaryQualification').removeClass('show');
        } else {
            $('#prior-Tertiary').removeClass('show');
            $('#prior-Tertiary').hide();
            //$('#divHighestTertiaryQualification').addClass('show');
        }
    } else {
        $('#prior-Tertiary').removeClass('show');
    }
}

function dateOfBirthField () {

    //alert($('#main-dob-field input').val());
    //e.g. '3/16/2002 12:00:00 AM'
    if ($('#main-dob-field input').val() !== '' && $('#main-dob-field input').val() !== undefined) {
        var existingDate = $('#main-dob-field input').val();
        var dateField = existingDate.split(' ');
        var dateSplit = dateField[0].split('/');
        //alert(dateSplit);
        $('#dob-day').find('option').removeAttr('selected');
        //$('#dob-day option[value='' + dateSplit[1] + '']').attr('selected', 'selected');
        $(`#dob-day option[value="${dateSplit[1]}"]`).prop('selected', true);
        dobInputValue.day = dateSplit[1];

        $('#dob-month').find('option').removeAttr('selected');
        //$('#dob-month option[value='' + dateSplit[0] + '']').attr('selected', 'selected');
        $(`#dob-month option[value="${dateSplit[0]}"]`).prop('selected', true);
        dobInputValue.month = dateSplit[0];

        $('#dob-year').find('option').removeAttr('selected');
        //$('#dob-year option[value='' + dateSplit[2] + '']').attr('selected', 'selected');
        $(`#dob-year option[value="${dateSplit[2]}"]`).prop('selected', true);
        dobInputValue.year = dateSplit[2];
    }

    //Validation
    $('.dob-field').off('change').change(function () {

        $(this).each(function () {

            var id = $(this).attr('id');
            if (id === 'dob-day') {
                dobInputValue.day = $(this).val();
            } else if (id === 'dob-month') {
                dobInputValue.month = $(this).val();
            } else if (id === 'dob-year') {
                dobInputValue.year = $(this).val();
            }
        });

        var dateString = `${dobInputValue.year}-${dobInputValue.month}-${dobInputValue.day}`;
        //alert(dateString);

        if (dobInputValue.year > '' && dobInputValue.month > '' && dobInputValue.day > '') {

            $('#main-dob-field input').val(dateString);

            if ((dobInputValue.month === 4 || dobInputValue.month === 6 || dobInputValue.month === 9 || dobInputValue.month === 11) && dobInputValue.day === 31) {
                alert(`Month ${dobInputValue.month} doesn't have 31 days!`);
                $('#dob-day').val('');
            } else if (dobInputValue.month === 2) { // check for february 29th
                var isleap = (dobInputValue.year % 4 === 0 && (dobInputValue.year % 100 !== 0 || dobInputValue.year % 400 === 0));
                if (dobInputValue.day > 29 || (dobInputValue.day === 29 && !isleap)) {
                    alert(`February ${dobInputValue.year} doesn't have ${dobInputValue.day} days!`);
                    $('#dob-day').val('');
                }
            }
        }

        $(this).valid();
    });
}

function bindEventsForConditionalFields () {
    //poor mans way of sorting out dependant fields

    bindEventsForStep2();
    bindEventsForStep3();
}

function bindEventsForStep2 () {
    //Step 2
    //$('#student-title input[type='radio']').change(function () {
    //    if ($(this).is(':checked') && $(this).val() === 'Other') {
    //        $('#dependant-student-title').addClass('show');
    //    } else {
    //        $('#dependant-student-title').removeClass('show');
    //    }
    //});

    if ($('.different-postal-address input[type="checkbox"]').is(':checked')) {
        $('.main-postal-address').show();
    }
    else {
        $('.main-postal-address').hide();
    }

    $('.different-postal-address input[type="checkbox"]').change(function () {
        if ($(this).is(':checked')) {
            $(this).closest('.main-address-field').addClass('show-postal-address');
            $('.main-postal-address').show();
        } else {
            $(this).closest('.main-address-field').removeClass('show-postal-address');
            $('.main-postal-address').hide();
        }
    });

    $('#residancy-status .chzn-select').change(function () {

        var $inputsWithChosenContainer = $('#CitizenshipOnPassport_dropDownList');

        if ($(this).val().indexOf('permanent resident') > -1) {
            $('#dependant-residancy-status').addClass('show');
            $('#dependant-residancy-status').show();

            $('#citizenship-status').addClass('required-field');
            //$inputsWithChosenContainer.val('').change();
            $inputsWithChosenContainer.rules('add', {
                required: true,
                messages: {
                    required: 'This field is required.'
                }
            });
        } else {
            $('#dependant-residancy-status').removeClass('show');
            $('#dependant-residancy-status').hide();

            if ($(this).val().indexOf('Australian') > -1) {
                $inputsWithChosenContainer.val('AUS').change();
            } else {
                $inputsWithChosenContainer.val('NZL').change();
            }
        }
        //alert($inputsWithChosenContainer.val());
    });

    $('#ethnicity .chzn-select').change(function () {

        var currentText = $(':selected', this).text();

        if (currentText.indexOf('Other') > -1) {
            ethnicOtherOptions[0] = true;
            ethnicMaoriOptions[0] = false;
        } else if (currentText.indexOf('Māori') > -1 || currentText.indexOf('Maori') > -1) {
            ethnicMaoriOptions[0] = true;
            ethnicOtherOptions[0] = false;
        } else {
            ethnicOtherOptions[0] = false;
            ethnicMaoriOptions[0] = false;
        }
        //alert('call setEthenicityFields() ethnicOtherOptions[0]= ' + ethnicOtherOptions[0] + ' ethnicMaoriOptions[0] = ' + ethnicMaoriOptions[0]);
        setEthenicityFields();
    });
    $('#ethnicity2 .chzn-select').change(function () {

        var currentText = $(':selected', this).text();

        if (currentText.indexOf('Other') > -1) {
            ethnicOtherOptions[1] = true;
            ethnicMaoriOptions[1] = false;
        } else if (currentText.indexOf('Māori') > -1 || currentText.indexOf('Maori') > -1) {
            ethnicMaoriOptions[1] = true;
            ethnicOtherOptions[1] = false;
        } else {
            ethnicOtherOptions[1] = false;
            ethnicMaoriOptions[1] = false;
        }
        //alert('call setEthenicityFields() ethnicOtherOptions[1]= ' + ethnicOtherOptions[1] + ' ethnicMaoriOptions[1] = ' + ethnicMaoriOptions[1]);
        setEthenicityFields();
    });
    $('#ethnicity3 .chzn-select').change(function () {

        var currentText = $(':selected', this).text();

        if (currentText.indexOf('Other') > -1) {
            ethnicOtherOptions[2] = true;
            ethnicMaoriOptions[2] = false;
        } else if (currentText.indexOf('Māori') > -1 || currentText.indexOf('Maori') > -1) {
            ethnicMaoriOptions[2] = true;
            ethnicOtherOptions[2] = false;
        } else {
            ethnicOtherOptions[2] = false;
            ethnicMaoriOptions[2] = false;
        }
        //alert('call setEthenicityFields() ethnicOtherOptions[2]= ' + ethnicOtherOptions[2] + ' ethnicMaoriOptions[2] = ' + ethnicMaoriOptions[2]);
        setEthenicityFields();
    });

    $('#disability input[type="radio"]').change(function () {
        if ($(this).is(':checked') && $(this).val() === 'Yes') {
            $('#dependant-disability').addClass('show');
            $('#dependant-disability').show();
        } else {
            $('#dependant-disability').removeClass('show');
            $('#dependant-disability').hide();
        }
    });
}

function bindEventsForStep3 () {
    //Step 3
    $('#highest-qualification .chzn-select').change(function () {
        if ($(this).val() === '09') {
            $('#dependant-highest-qualification').addClass('show');
        } else {
            $('#dependant-highest-qualification').removeClass('show');
        }
    });

    $('#first-year input[type="radio"]').change(function () {
        if ($(this).is(':checked') && $(this).val() === 'No') {
            $('#dependant-first-year').addClass('show');
        } else {
            $('#dependant-first-year').removeClass('show');
        }
    });

    $('#enroled-programme input[type="radio"]').change(function () {
        if ($(this).is(':checked') && $(this).val() === 'Yes') {
            $('#dependant-enroled-programme').addClass('show');
            $('#dependant-enroled-programme').show();
        } else {
            $('#dependant-enroled-programme').removeClass('show');
            $('#dependant-enroled-programme').hide();
        }
    });

    $('#divFirstYearOfStudy input[type="radio"]').change(function () {

        //Set validation
        if ($('#HighestTertiaryQualification_dropDownList').val() === '') {
            //alert('HighestTertiaryQualification_dropDownList is null');
            $('#HighestTertiaryQualification_dropDownList').val('15').change();
            $('#HighestTertiaryQualification_dropDownList').trigger('chosen:updated');
        }

        if ($(this).is(':checked') && $(this).val() === 'No') {
            $('#prior-Tertiary').addClass('show');
            $('#prior-Tertiary').show();
        } else {
            $('#prior-Tertiary').removeClass('show');
            $('#prior-Tertiary').hide();
        }
    });

}

/**
    * generates option markup
    * @param  {string} text     optional, text to show on option: <option>text</option>
    * @param  {string} value    optional, value to show on option: <option value='value'></option>
    * @param  {bool} selected 	 optional, add selected attr: <option selected='selected'></option>
    * @return {opject}          returns jquery obj
    */
function generateOption (text, value, selected) {
    var $option = $('<option></option>');

    text ? $option.text(text).val(text) : $option.text('Please Select');

    value ? $option.val(value) : $option.val('');

    selected ? $option.attr('selected', 'selected') : '';

    // if both text and value args are undefined, return selected option
    if (!text && !value) {
        $option.attr('selected', 'selected');
    }

    return $option;
}

/**
    * generates array of year options, by default it generates future years
    * @param  {anyting} reverse 	optional, keep undefined if you wna get future years
    * @param  {int} limit 			optional, maximum number of years to show
    * @return {array}         		returns an array of jQuery objects
    */
function generateYears (reverse, limit) {
    var totalSteps = totalYearsToShow;
    var options = [];
    if (limit) { totalSteps = limit; }

    // var defaultOption = generateOption();
    // options.push(defaultOption);

    if (reverse) {
        for (let i = 0; i < totalSteps; i++) {
            let text = currentYear - i;
            let option = generateOption(text, text);
            options.push(option);
        }
    } else {
        for (let i = 0; i < totalSteps; i++) {
            let text = currentYear + i;
            let option = generateOption(text, text);
            options.push(option);
        }
    }
    return options;
}

function ignoredFields (stepNumber) {
    return `:hidden:not(${stepNumber} .chosen-done .has-feedback)`;
}

function showStep (stepNumber) {

    if (currentStepNumber === stepNumber) {
        return;
    }

    var $step = $(stepNumber);
    $step.addClass('active');

    $currentActiveStep.removeClass('active');

    currentStepNumber = stepNumber;
    $currentActiveStep = $step;

    //validationInstance.settings.ignore = ignoredFields(stepNumber);

    // console.log( validationInstance.settings.ignore );

    $window.scrollTop(0);

}

TWoA.Enrolment.bindAutocomplete = function bindAutocomplete (data) {
    data.autocomplete = new google.maps.places.Autocomplete($(data.autocompleteSelector)[0], { types: ['address'], componentRestrictions: { country: 'nz' } });
    data.autocomplete.addListener('place_changed', data.callback);
};

TWoA.Enrolment.fillInAddress = function fillInAddress (data) {

    var place = data.autocomplete.getPlace();
    $(`${data.streetNumber}, ${data.suburb}, ${data.townCity}, ${data.postCode}`).val('');

    for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        var placeValue = place.address_components[i]['long_name'];

        switch (addressType) {
        case 'street_number':
            $(data.streetNumber).val(placeValue);
            break;
        case 'route':
            $(data.streetNumber).val($(data.streetNumber).val() + ' ' + placeValue);
            break;
        case 'sublocality_level_1':
            $(data.suburb).val(placeValue);
            break;
        case 'locality':
            var suburbValue = $(data.suburb).val();
            if (suburbValue === '') {
                $(data.suburb).val(placeValue);
            } else {
                $(data.townCity).val(placeValue);
            }
            break;
        case 'administrative_area_level_1':
            var townCityValue = $(data.townCity).val();
            if (townCityValue === '') {
                $(data.townCity).val(placeValue);
            //} else if (townCityValue !== placeValue) {
            //    $(data.townCity).val($(data.townCity).val() + ', ' + placeValue);
            }
            break;
        case 'postal_code':
            $(data.postCode).val(placeValue);
            break;
        default:
        }
    }
};

$('#form').on('keyup keypress', function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

//check for loaction and program then show a text box
$('#DeliveryLocation_dropDownList').on('change', function () {
    var location = $('#DeliveryLocation_dropDownList').val();
    if (location === 'a0L28000000PnyCEAS') {
        $('#ProgrammeOfInterest_dropDownList').on('change', function () {
            var program = $('#ProgrammeOfInterest_dropDownList').val();
            if (program === 'a0J0K00000R3ofrUAB') {
                $('#groupEnrolment').show();
                checkIsGroup();
            } else {
                $('#groupEnrolment #GroupEnrollment_list_1').prop('checked', true);
                $('#GroupEnrollmentName').val('');
                $('#groupEnrolment').hide();
            }
        });
    } else {
        $('#groupEnrolment #GroupEnrollment_list_1').prop('checked', true);
        $('#groupEnrolment').hide();
        $('#GroupEnrollmentName').val('');
    }
});

//hide and show a text field based on selection
$('#GroupEnrollment_list_0').on('click', function () {
    var showGroup = $('#GroupEnrollment_list_0').val();
    if (showGroup === '1') {
        $('#GroupEnrollmentName').show();
    }
});

$('#GroupEnrollment_list_1').on('click', function () {
    var showGroup = $('#GroupEnrollment_list_1').val();
    if (showGroup === '0') {
        $('#GroupEnrollmentName').hide();
        $('#GroupEnrollmentName').val('');
    }
});

//check whether or not the user has already checked this field or not
function checkIsGroup () {
    var isGroup = $('#groupEnrolment #GroupEnrollment_list_0').is(':checked');
    if (!isGroup) {
        $('#GroupEnrollment_list_1').prop('checked', true);
        $('#GroupEnrollmentName').hide();
    } else {
        $('#GroupEnrollment_list_0').prop('checked', true);
        $('#GroupEnrollmentName').show();
    }
}

//when a new user selects the correct program
function checkNewUser () {
    var program = $('#ProgrammeOfInterest_dropDownList').val();

    if (program !== 'a0J0K00000R3ofrUAB') {
        $('#groupEnrolment').hide();
    } else {
        checkIsGroup();
    }
}


// WEBPACK FOOTER //
// ./Assets/js/TeWanangaRedesign/online-enrolment-form.js